import type { InjectionKey } from 'vue';
import { inject } from 'vue';

import type { Locale } from '@/config/build';

export const LOCALE_CONFIG_KEY = Symbol('app-config') as symbol & InjectionKey<Locale>;

export function useLocaleConfig() {
  const config = inject<Locale>(LOCALE_CONFIG_KEY);

  if (!config) {
    throw new Error('Inject LocaleConfig was called before initialization. Did you forget to inject LocaleConfig?');
  }

  return config;
}
